<template>
  <v-form ref="form" lazy-validation @submit.prevent="onSignin">
    <v-card-text>
      <v-row>
        <v-col v-if="project.form.passDescription" cols="12" v-html="project.form.passDescription" />
        <v-col v-else cols="12">
          {{ $t('v.signIn') }}
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center" class="py-2 grey--text">
          <v-icon aria-hidden="false">
            mdi-account
          </v-icon>
          {{ email }}
        </v-col>
        <v-col cols="12" class="pt-0">
          <input name="email" :value="email" type="text" autocomplete="username" class="hidden">
          <v-text-field ref="password" v-model="password" name="password" :label="$t('v.password')" :type="showPassword ? 'text' : 'password'" :solo="project.form.solo" :dense="project.form.small" :outlined="project.form.outlined" required autocomplete="current-password">
            <template #append>
              <v-btn icon tabindex="-1" @click="showPassword = !showPassword">
                <v-icon>{{ showPassword ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          {{ $t('v.forgotPassword') }}
          <a href="#" @click="resetPassword">
            {{ $t('v.recoverPassword') }}
          </a>
        </v-col>
      </v-row>

      <v-row align="center" class="pt-11">
        <v-col cols="auto">
          <v-btn :small="project.form.small" nuxt text @click="previous">
            {{ $t('v.back') }}
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-btn :small="project.form.small" :loading="loading" :disabled="!signinEnabled" color="accent" class="px-11" type="submit">
            {{ $t('v.send') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StepMixin from './StepMixin'

export default {
  mixins: [
    StepMixin
  ],

  props: {
    email: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    password: '',
    showPassword: false,
    loading: false
  }),

  computed: {
    signinEnabled () {
      return this.password && !this.loading
    },

    ...mapGetters({
      project: 'projects/project'
    })
  },

  watch: {
    email () {
      this.focus()
    }
  },

  mounted () {
    this.focus()
  },

  methods: {
    async onSignin () {
      if (!this.$refs.form.validate()) {
        return false
      }

      try {
        this.loading = true

        await this.wdotAdd({ event: 'trySignIn', email: this.email })

        await this.signInSn({ email: this.email, password: this.password })

        this.next()
      } catch (error) {
        this.showSnError(error.message)
        this.$logError(error)
      } finally {
        this.loading = false
      }
    },

    resetPassword () {
      this.$emit('reset')
    },

    focus () {
      setTimeout(() => {
        this.$refs.password.focus()
      }, 100)
    },

    ...mapActions({
      signInSn: 'auth/signInSn',
      showSnError: 'auth/showSnError',
      wdotAdd: 'wdots/add'
    })
  }
}
</script>

<style scoped>
</style>
